export const screenSizes = {
  sx: 300,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1500,
};
